/* ============================================================
   CRC-PLX — parallax leve: rAF único + lerp .08 + translate
   ============================================================ */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MAP = [
    ['.crc-collage .crc-sticker', -30],
    ['.crc-polaroid', -12, true],
    ['.crc-dude-bubble', -24],
    ['.crc-videoband__badge', -18],
    ['.crc-meet__art img', -20]
  ];

  var els = [];
  MAP.forEach(function (row) {
    document.querySelectorAll(row[0]).forEach(function (el, i) {
      el.setAttribute('data-plx', '');
      els.push({ el: el, amp: row[2] && (i % 2) ? -row[1] : row[1], cur: 0, on: false });
    });
  });
  if (!els.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      for (var i = 0; i < els.length; i++) if (els[i].el === en.target) els[i].on = en.isIntersecting;
    });
  }, { rootMargin: '25% 0px' });
  els.forEach(function (o) { io.observe(o.el); });

  var vh = innerHeight, mul = 1;
  function measure() {
    vh = innerHeight;
    mul = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--plx-m')) || 1;
  }
  measure();
  addEventListener('resize', measure, { passive: true });

  (function tick() {
    for (var i = 0; i < els.length; i++) {
      var o = els[i];
      if (!o.on) continue;
      if (o.el.hasAttribute('data-fx') && !o.el.classList.contains('fx-in')) continue;
      var r = o.el.getBoundingClientRect();
      var p = (r.top - o.cur + r.height / 2 - vh / 2) / (vh / 2);
      p = Math.max(-1, Math.min(1, p));
      var target = p * o.amp * mul;
      if (Math.abs(target - o.cur) < .05) continue;
      o.cur += (target - o.cur) * 0.08;
      o.el.style.translate = '0 ' + o.cur.toFixed(2) + 'px';
      o.el.classList.add('plx-on');
    }
    requestAnimationFrame(tick);
  })();
})();
